import React from "react";
import { OfferingDetail } from "../components/OfferingDetail";
export default function HeliosPage({ onDemo }) { return <OfferingDetail slug="helios" onDemo={onDemo} />; }